import { combineReducers } from 'redux'

import scenarios from './scenarios'
import accounts from './accounts'
import settings from './settings'
import toolTips from './toolTips'

export default combineReducers({ accounts, scenarios, settings, toolTips })
